/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UnresolvedCommentIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Unresolved Comment',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30 4a2.002 2.002 0 0 1 2 2v16a2.002 2.002 0 0 1-2 2H17.171l-.585.586L10 31.172V24H6a2.002 2.002 0 0 1-2-2V6a2.002 2.002 0 0 1 2-2h24Zm0-2H6a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h2v8.793a.5.5 0 0 0 .854.354L18 26h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Z"
    />
    <rect x="10" y="12" width="16" height="4" rx=".5" ry=".5" />
  </svg>`;
};
